import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.00004 9.16659C8.36823 9.16659 8.66671 8.86811 8.66671 8.49992C8.66671 8.13173 8.36823 7.83325 8.00004 7.83325C7.63185 7.83325 7.33337 8.13173 7.33337 8.49992C7.33337 8.86811 7.63185 9.16659 8.00004 9.16659Z", stroke: "#1F2D67", style: {
  stroke: "#1F2D67",
  stroke: "color(display-p3 0.1233 0.1774 0.4055)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.6667 9.16659C13.0349 9.16659 13.3333 8.86811 13.3333 8.49992C13.3333 8.13173 13.0349 7.83325 12.6667 7.83325C12.2985 7.83325 12 8.13173 12 8.49992C12 8.86811 12.2985 9.16659 12.6667 9.16659Z", stroke: "#1F2D67", style: {
  stroke: "#1F2D67",
  stroke: "color(display-p3 0.1233 0.1774 0.4055)",
  strokeOpacity: 1
}, strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.33329 9.16659C3.70148 9.16659 3.99996 8.86811 3.99996 8.49992C3.99996 8.13173 3.70148 7.83325 3.33329 7.83325C2.9651 7.83325 2.66663 8.13173 2.66663 8.49992C2.66663 8.86811 2.9651 9.16659 3.33329 9.16659Z", stroke: "black", style: {
  stroke: "black",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgMenu);
export default ForwardRef;
